/**
 * @generated SignedSource<<6342dd24bb795fed2e52e3ebc62d3c23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkAvailabilityTag_userProfile$data = {
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly isCurrentlyAvailable: boolean;
  };
  readonly " $fragmentType": "WorkAvailabilityTag_userProfile";
};
export type WorkAvailabilityTag_userProfile$key = {
  readonly " $data"?: WorkAvailabilityTag_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkAvailabilityTag_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkAvailabilityTag_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyAvailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "435c3ab700eb15cf85419f290da95f4d";

export default node;
